import React from 'react'
import { WEB_URL_CONSTANTS } from 'constants/web-url-constants'
import PropTypes from 'prop-types'

const propTypes = {
  url: PropTypes.string
}

const defaultProps = {
  url: ''
}

const GoToBlogPostPage = ({ url }) => (
  url &&
    <h3>
      { 'Go to Blog page ' }
      <a
        className='text-primary'
        href={ `${WEB_URL_CONSTANTS.HOMEPAGE}/blog/${url}` }
        target='_blank' rel='noopener noreferrer'
      >
        { 'here' }
      </a>
    </h3>
)

GoToBlogPostPage.propTypes    = propTypes
GoToBlogPostPage.defaultProps = defaultProps

export default GoToBlogPostPage
